import React, { useEffect, useState } from "react";
import styles from "../OrganizationForm.module.sass";
import PackageDropdownQuantitySelector from "../../Packages/PackageDropdownQuantitySelector/PackageDropdownQuantitySelector";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const PackagesTab = ({ packages, selectedPackages, handleChange, entitieID }) => {
    const { i18n } = useGlobalValue();
    const [showInfoContainer, setShowInfoContainer] = useState(false);
    const [initialSelectedPackagesIds, setInitialSelectedPackagesIds] = useState([]);
    const selectedPackagesString = JSON.stringify(selectedPackages);

    useEffect(() => {
      if(selectedPackages && selectedPackages.length){
        const selectedIds = selectedPackages.map(item => item.packageId);
        setInitialSelectedPackagesIds(selectedIds);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      const selectedPackagesIds = selectedPackages && selectedPackages.length ? selectedPackages.map(item => item.packageId) : [];

      let hasMissingIds = false;
      initialSelectedPackagesIds.forEach((initialPackageId) => {
        const isMissing = !selectedPackagesIds.includes(initialPackageId);
        if (isMissing) {
          hasMissingIds = true;
        }
      });

      setShowInfoContainer(hasMissingIds);
    },[selectedPackagesString, selectedPackages, initialSelectedPackagesIds]);

    return (
        <>
            { showInfoContainer ? (
                <div className={styles["package-warning-container"]}>
                    <small>{i18n`delete_projects_associations_warning`}</small>
                </div>
            ) : null}
            <PackageDropdownQuantitySelector
                packages={packages}
                selectedPackages={selectedPackages}
                handleChange={handleChange}
                entitieID={entitieID}
                entitieKey={"organizationId"}
            />
        </>
    );
};

export default PackagesTab;
